export default "__VITE_ASSET__BzB4wBgg__"